import { MerchantDevice } from '@m4a3/api-client/dist/models/merchant-device.interface';
import {
  GET_MERCHANT_DEVICES_FAILURE,
  GET_MERCHANT_DEVICES_PENDING,
  GET_MERCHANT_DEVICES_SUCCESS,
  CREATE_MERCHANT_DEVICES_FAILURE,
  CREATE_MERCHANT_DEVICES_PENDING,
  CREATE_MERCHANT_DEVICES_SUCCESS,
  UPDATE_MERCHANT_DEVICES_SUCCESS,
  UPDATE_MERCHANT_DEVICES_PENDING,
  UPDATE_MERCHANT_DEVICES_FAILURE,
  DELETE_MERCHANT_DEVICES_FAILURE,
  DELETE_MERCHANT_DEVICES_PENDING,
  DELETE_MERCHANT_DEVICES_SUCCESS,
} from 'actions/actionTypes';
import { AnyAction } from 'redux';

interface MerchantDeviceState {
  merchantDevices: MerchantDevice[],
  isLoadingMerchantDevices: boolean;
  merchantDevicesLoadingError: Error;
  isUpdatingMerchantDevice: boolean;
  isDeletingMerchantDevice: boolean;
  isCreatingMerchantDevice: boolean;
  merchantDeviceCreationError: Error;
  merchantDeviceUpdateError: Error;
  merchantDeviceDeletionError: Error;
}
const defaultState: MerchantDeviceState = {
  merchantDevices: [],
  isLoadingMerchantDevices: false,
  merchantDevicesLoadingError: null,
  isCreatingMerchantDevice: false,
  merchantDeviceCreationError: null,
  isUpdatingMerchantDevice: false,
  isDeletingMerchantDevice: false,
  merchantDeviceUpdateError: null,
  merchantDeviceDeletionError: null,
};

export default (state: MerchantDeviceState = defaultState, action: AnyAction) => {
  switch (action.type) {
    case GET_MERCHANT_DEVICES_PENDING:{
      return {
        ...state,
        isLoadingMerchantDevices: true,
        merchantDevicesLoadingError: null,
      }
    }
    case GET_MERCHANT_DEVICES_SUCCESS:{
      return {
        ...state,
        merchantDevices: action.payload,
        isLoadingMerchantDevices: false,
        merchantDevicesLoadingError: null,
      }
    }
    case GET_MERCHANT_DEVICES_FAILURE:{
      return {
        ...state,
        isLoadingMerchantDevices: false,
        merchantDevices: [],
        merchantDevicesLoadingError: action.payload,
      }
    }
    case CREATE_MERCHANT_DEVICES_FAILURE:{
      return {
        ...state,
        isCreatingMerchantDevice: false,
        merchantDeviceCreationError: action.payload,
      }
    }
    case CREATE_MERCHANT_DEVICES_PENDING:{
      return {
        ...state,
        isCreatingMerchantDevice: true,
        merchantDeviceCreationError: null
      }
    }
    case CREATE_MERCHANT_DEVICES_SUCCESS:{
      return {
        ...state,
        isCreatingMerchantDevice: false,
        merchantDeviceCreationError: null
      }
    }
    case UPDATE_MERCHANT_DEVICES_FAILURE:{
      return {
        ...state,
        isUpdatingMerchantDevice: false,
        merchantDeviceUpdateError: action.payload,
      }
    }
    case UPDATE_MERCHANT_DEVICES_PENDING:{
      return {
        ...state,
        isUpdatingMerchantDevice: true,
        merchantDeviceUpdateError: null
      }
    }
    case UPDATE_MERCHANT_DEVICES_SUCCESS:{
      return {
        ...state,
        isUpdatingMerchantDevice: false,
        merchantDeviceUpdateError: null
      }
    }
    case DELETE_MERCHANT_DEVICES_FAILURE:{
      return {
        ...state,
        isDeletingMerchantDevice: false,
        merchantDeviceDeletionError: action.payload,
      }
    }
    case DELETE_MERCHANT_DEVICES_PENDING:{
      return {
        ...state,
        isDeletingMerchantDevice: true,
        merchantDeviceDeletionError: null
      }
    }
    case DELETE_MERCHANT_DEVICES_SUCCESS:{
      return {
        ...state,
        isDeletingMerchantDevice: false,
        merchantDeviceDeletionError: null
      }
    }
    default:
      return state;
    }
};
